import { render, staticRenderFns } from "./ApiImage.vue?vue&type=template&id=709ff968&"
import script from "./ApiImage.vue?vue&type=script&lang=js&"
export * from "./ApiImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports